Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var cn = require('classnames');
var coreComponentsSkeleton = require('../../skeleton');
var hooks = require('@alfalab/hooks');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var cn__default = /*#__PURE__*/_interopDefaultCompat(cn);

var styles = {"skeletonText":"typography__skeletonText_scldn","left":"typography__left_scldn","center":"typography__center_scldn","right":"typography__right_scldn"};
require('./use-skeleton.css');

function useSkeleton(showSkeleton, skeletonProps) {
    var _a = React.useState(), skeletonParams = _a[0], setSkeletonParams = _a[1];
    var textRef = React.useRef(null);
    hooks.useLayoutEffect_SAFE_FOR_SSR(function () {
        if (showSkeleton && textRef.current) {
            var style = getComputedStyle(textRef.current);
            var textHeight = textRef.current.offsetHeight;
            var fontSize = parseInt(style.fontSize, 10);
            var lineHeight = parseInt(style.lineHeight, 10);
            var padding = (lineHeight - fontSize) % 2 === 0
                ? (lineHeight - fontSize) / 2
                : (lineHeight - fontSize - 1) / 2;
            var rows = (skeletonProps === null || skeletonProps === void 0 ? void 0 : skeletonProps.rows)
                ? skeletonProps === null || skeletonProps === void 0 ? void 0 : skeletonProps.rows
                : Math.ceil(textHeight / lineHeight);
            setSkeletonParams({
                height: lineHeight - padding * 2,
                padding: "".concat(padding, "px 0"),
                rows: rows,
            });
        }
        else {
            setSkeletonParams(undefined);
        }
    }, [showSkeleton, skeletonProps === null || skeletonProps === void 0 ? void 0 : skeletonProps.rows]);
    var renderSkeleton = function (props) {
        if (showSkeleton && skeletonParams) {
            return (React__default.default.createElement("div", { className: cn__default.default(skeletonProps === null || skeletonProps === void 0 ? void 0 : skeletonProps.wrapperClassName, props.wrapperClassName, (skeletonProps === null || skeletonProps === void 0 ? void 0 : skeletonProps.align) && styles[skeletonProps.align]), "data-test-id": props.dataTestId }, tslib.__spreadArray([], Array(skeletonParams.rows), true).map(function (_, idx) {
                var width = Array.isArray(skeletonProps === null || skeletonProps === void 0 ? void 0 : skeletonProps.width)
                    ? skeletonProps === null || skeletonProps === void 0 ? void 0 : skeletonProps.width[idx]
                    : skeletonProps === null || skeletonProps === void 0 ? void 0 : skeletonProps.width;
                return (
                // eslint-disable-next-line react/no-array-index-key
                React__default.default.createElement("div", { key: idx, style: { width: width, padding: skeletonParams.padding } },
                    React__default.default.createElement(coreComponentsSkeleton.Skeleton, { visible: true, className: styles.skeletonText },
                        React__default.default.createElement("div", { style: { height: skeletonParams.height } }))));
            })));
        }
        return null;
    };
    return { renderSkeleton: renderSkeleton, textRef: textRef };
}

exports.useSkeleton = useSkeleton;
